
/**
 * PALTFORM MODULES
 */
import Emitter       from '@shared/services/main/events';
import RequestClient from '@shared/services/main/request-client';
import BaseService   from '@shared/services/base/BaseService'
import ENDPOINTS     from '@shared/lib/constants/endpoints';
import EVENT_NAMES   from '@shared/lib/constants/events';

import SessionTokenTrait from '@shared/services/session/services/traits/SessionTokenTrait';

/**
 * Regsiter Service
 *
 * @class      SessionService (name)
 */
function SessionService(component) {
  this.component           = component;
  this.event_group         = EVENT_NAMES.PLATFORM.SESSIONS;
  this.hostname            = process.env.REACT_APP_PLATFORM_API_BASE_URL;
  this.read_endpoint       = this.hostname + ENDPOINTS.PLATFORM.SESSIONS_START;
  this.token_read_endpoint = this.hostname + ENDPOINTS.PLATFORM.SESSIONS_TOKEN;
  this.used_interceptor    = false;
}

SessionService.prototype = Object.assign(SessionService.prototype, BaseService.prototype);
SessionService.prototype = Object.assign(SessionTokenTrait.prototype, BaseService.prototype);

/**
 * Registers Regsiter events, this follows naming convention
 *
 * @param      {Object}       self         The caller instance
 * @param      {BaseService}  service      The service
 * @param      {string}       module_name  The module name
 */
SessionService.prototype.registerSessionEvents = function(self, service) {
  var event_callback_map = {};
  event_callback_map[this.event_group.START_PROCEED] = 'onStartProceed';
  event_callback_map[this.event_group.START_SUCCESS] = 'onStartSuccess';
  event_callback_map[this.event_group.START_FAIL]    = 'onStartFail';
  this.registerEvents(event_callback_map, service);
  return this;
}

/**
 * Removes Regsiter events.
 *
 * @param      {<type>}  self         The object
 * @param      {<type>}  service      The service
 * @param      {string}  module_name  The module name
 */
SessionService.prototype.removeSessionEvents = function() {
  this.removeEvents([
    this.event_group.START_PROCEED,
    this.event_group.START_SUCCESS,
    this.event_group.START_FAIL
  ]);
  return this;
}


/**
 * Called when Regsiter proceed.
 *
 * @param      {Object}  arg1       The argument 1
 * @param      {<type>}  arg1.data  The data
 */
SessionService.prototype.onStartProceed = function() {
  let token_source = this.renewCancelToken(RequestClient, this.event_group.START_PROCEED);
  let request = RequestClient.head(this.read_endpoint, {
    cancelToken: token_source.token,
  });
  this.bindResultEvents(
    request,
    this.event_group.START_SUCCESS,
    this.event_group.START_FAIL
  );
  request.finally(() => {
  });
};

/**
 * Called on Regsiter success.
 */
SessionService.prototype.onStartSuccess = function() {
  // Try to capture platform session_id from cookie after session starts
  // The cookie is set by the server, so we read it from document.cookie
  setTimeout(() => {
    if (typeof document !== 'undefined') {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === 'caribe7_session' && value) {
          const { LocalStorage } = require('@shared/services/main/storage');
          LocalStorage.set('platform_session_id', value);
          console.log('[SessionService] Stored platform_session_id from cookie after session start:', value.substring(0, 10) + '...');
          break;
        }
      }
    }
  }, 200);
  
  /**
   * ALso emit other extensions
   */
  Emitter.emit(EVENT_NAMES.PLATFORM.SESSIONS.START_SUCCESS_AFTER, {});
}

/**
 * Called on Regsiter fail.
 *
 */
SessionService.prototype.onStartFail = function() {
  return true;
}

export default SessionService;